import { MultiSelectItem } from '@/main/store/@types/dropdown.d';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { TABLE_DATA, ENTITY, START_LOADING } from '@/main/store/listEditTypes';
import { NahradniHodinovaSazba } from '@/modules/ciselnik/zakaznicke/zakaznickaSkupina/fakturacniProfil/nahradniHodinovaSazba';
import { SmluvniCenaND } from '@/modules/ciselnik/zakaznicke/zakaznickaSkupina/fakturacniProfil/smluvniCenaND';
import { NahradniSazbaLakovaci } from '@/modules/ciselnik/zakaznicke/zakaznickaSkupina/fakturacniProfil/nahradniSazbaLakovaci';

import { DEPENDENT_TABLES as depTableNames, editActions } from './types';
import { apiProvider } from '../api';
import { NAME, apiFunctionNames, CRUMB_LABEL_KEY } from '../constants';

const edit = {
	CenotvorbandPzn: null as number | null,
	DrMatSzb: null as number | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	FakturaceprofilDefPrp: null as boolean | null,
	FakturaceprofilId: null as number | null,
	HodSzbNahr: null as number | null,
	HodSzbNahr1: null as number | null,
	HodSzbNahr2: null as number | null,
	HodSzbNahr8: null as number | null,
	PcPevnaPneu: null as number | null,
	SlevaCv: null as number | null,
	SlevaEmise: null as number | null,
	SlevaLak: null as number | null,
	SlevaMat: null as number | null,
	SlevaMatSkryta: null as number | null,
	SlevaProdejzdeMat: null as number | null,
	SlevaProdejzdeSlz: null as number | null,
	SlevaPujcpa: null as number | null,
	SlevaSlz: null as number | null,
	SlevamatSk: null as number | null,
	Sm2ddpcjdnprezPzn: null as number | null,
	StariVozuDo: null as number | null,
	StariVozuOd: null as number | null,
	Text: null as string | null,
	Text2DdNv: null as string | null,
	Text2DdOv: null as string | null,
	Text2DdSm: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VyrazenDat: null as Date | null,
	ZakaznikSk: null as number | null,
	ZvlrdphPzn: null as number | null,

	Provozovna: [] as MultiSelectItem[],
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		CenotvorbandPzn: [],
		SlevamatSk: [],
		Sm2ddpcjdnprezPzn: [],
		ZvlrdphPzn: [],
		Provozovna: [],
	},
	depTableNames,
	depTableSettings: {
		[NahradniHodinovaSazba.name]: { filter(state) { return { FakturaceprofilId: state.edit.FakturaceprofilId }; } },
		[SmluvniCenaND.name]: { filter(state) { return { FakturaceprofilId: state.edit.FakturaceprofilId }; } },
		[NahradniSazbaLakovaci.name]: { filter(state) { return { FakturaceprofilId: state.edit.FakturaceprofilId }; } },
	},
	edit,
	localState: {
		tablesToRefresh: [] as string[],
		prevzetiApi: null as string | null,
	},
	extraActions: {
		async [editActions.PREVZETI_HODNOT]({ state, commit, dispatch }, { row }: { row: Record<string, any> }) {
			const allLoading = state.localState.prevzetiApi === apiFunctionNames.copyFakturaceProfilAll;

			state.localState.tablesToRefresh.forEach((tableName) => commit(START_LOADING, tableName));
			allLoading && commit(START_LOADING);

			await (apiProvider as any)[state.localState.prevzetiApi!]({ idZ: row.FAKTURACEPROFIL_ID, idDo: state.edit.FakturaceprofilId! });

			allLoading && dispatch(`${ENTITY}`, { id: state.edit.FakturaceprofilId, edit: true }).finally(() => { state.loadingCount -= 1; });
			await Promise.all(state.localState.tablesToRefresh.map((table) => (
				dispatch(`${table}_${TABLE_DATA}`, { filter: { FakturaceprofilId: state.edit.FakturaceprofilId } })
			)));
		},
	},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
